import { Progress } from "@/components/ui/progress";
import { STAGE_INFO, type ProgressStage } from "@/hooks/use-section-progress";

interface SectionGenerationProgressProps {
  stage: ProgressStage;
  testId?: string;
}

export function SectionGenerationProgress({ stage, testId }: SectionGenerationProgressProps) {
  const info = STAGE_INFO[stage] ?? STAGE_INFO.preparing;
  return (
    <div
      className="pointer-events-none absolute inset-0 flex items-center justify-center"
      data-testid={testId}
    >
      <div className="pointer-events-auto w-[88%] max-w-sm rounded-md border bg-background/90 px-3 py-2 shadow-sm backdrop-blur-sm dark:bg-background/80">
        <div
          className="mb-1.5 text-xs font-medium text-foreground"
          aria-live="polite"
          data-testid={testId ? `${testId}-label` : undefined}
        >
          {info.label}
        </div>
        <Progress
          value={info.percent}
          className="h-1.5"
          data-testid={testId ? `${testId}-bar` : undefined}
        />
      </div>
    </div>
  );
}
